import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { Step } from '../views/Step';
import { MessageKey } from './MessageKey';
import { Integration } from 'signup-constants/Integration';
import { getMicroappKey } from '../routing/getMicroappKey';
import { Microapp } from 'signup-constants/Microapp';
const SpecificMessaging = new Map([[Integration.Wordpress, () => new Map([[Step.WordpressAuthorization, MessageKey.WordpressConnect], [Step.WordpressConnectRedirect, MessageKey.WordpressConnect], [Step.CrmExperienceLevel, null]])], [Microapp.CampaignAssistant, () => new Map([[Step.LandingPage, MessageKey.CampaignAssistant]])], [Microapp.BlogIdeasGenerator, () => new Map([[Step.LandingPage, MessageKey.BlogGenerator]])]]);
export const getSpecificMessagingFunction = () => {
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  const microappKey = getMicroappKey();
  return microappKey && SpecificMessaging.get(microappKey) || integrationKey && SpecificMessaging.get(integrationKey) || SpecificMessaging.get(flowKey);
};